function updateTitleElement(element) {
  /* Swap out the FS title element with an H1 */
  const pageParent=element.closest("#fs-serp-page");
  const titleElement = pageParent.querySelector('.searchTerm.fs-summary-search-term');
  // This hooks runs multiple times, and it won't always have the titleElement ready
  if (titleElement && titleElement.nodeName !== 'H1') {
    const newH1 = document.createElement('h1');
    newH1.className = titleElement.className; // Retain any existing classes
    newH1.classList.add('altered-fs-summary-search-term')
    newH1.innerHTML = titleElement.innerHTML;
    titleElement.replaceWith(newH1);
  }
}

function loadCollectionBanner(topCenterContainerElement) {const bannerSelector = window.innerWidth <= 480 ? '#collection_banner_search_result_top_mobile' : '#collection_banner_search_result_top_desktop';
  const banner = document.querySelector(bannerSelector);
  const fsBanner = document.querySelector('#fast-simon-serp-app')?.shadowRoot?.querySelector('.fs-banner-wrapper');
  if(fsBanner) {
    fsBanner.parentNode.removeChild(fsBanner);
  }
  const loadedBanner = topCenterContainerElement.querySelector(bannerSelector);
  if(banner && !loadedBanner) {
    banner.parentNode.removeChild(banner);
    banner.classList.remove('hidden');
    const containerWidth = topCenterContainerElement.parentNode.offsetWidth;
    const imgElement = banner.querySelector('img');
    imgElement.style.width = `${containerWidth}px`; /* we have to manually set the width, since it doesn't follow the parent container width after moving the banner */
    topCenterContainerElement.parentNode.prepend(banner);
  }
}

function updateToggleStateWhenRemoveableTagsClickedButTopPageHookNotTriggered(topCenterContainerElement) {
  document.addEventListener(`updateToggleStateWhenRemoveableTagsClickedButTopPageHookNotTriggered`, () => {
    setTopContainerClass(topCenterContainerElement);
    document.dispatchEvent(new CustomEvent('updateToggleStateWhenRemoveableTagsClicked'));
  });
}

function setTopContainerClass(topCenterContainerElement) {
  setTimeout(() => {  /* we need the timeout to wait for the url filters to be updated */
    topCenterContainerElement.classList.remove('margin-bottom-6rem', 'margin-bottom-3rem');
    const currentQueryFiltersString = getFiltersQueryString();
    const removableTagsWrapper = topCenterContainerElement.querySelector(".removable-tags-wrapper");
    let removableTagsUnhidden = null;
    if(removableTagsWrapper) {
      removableTags = (removableTagsWrapper.querySelectorAll("div.removable-tag"));
      removableTagsUnhidden = Array.from(removableTags).filter(tag => tag.style.display != "none");
    }
    let topCenterContainerClassName = 'margin-bottom-3rem';
    if(removableTagsWrapper && removableTags && removableTagsUnhidden.length > 0){
      topCenterContainerClassName = 'margin-bottom-6rem';
    }
    topCenterContainerElement.classList.add(topCenterContainerClassName);
    changeCanadaWideTagName(topCenterContainerElement);
    
      changeInStockTagsNames(topCenterContainerElement);
    
  }, 500);
}

function addEventListenersForRemovableTagsWrapper(topCenterContainerElement) {
  setTimeout(() => {
    const removableTagsWrapper = topCenterContainerElement.querySelector('.removable-tags-wrapper');
    if(removableTagsWrapper) {
      removableTagsWrapper.addEventListener('click', function(event) {
        setTopContainerClass(topCenterContainerElement);
        document.dispatchEvent(new CustomEvent('updateToggleStateWhenRemoveableTagsClicked'));
      });
    } 
    //sometimes, removableTagsWrapper element is on dom but returned as null so click event was not attached successfully
    setTopContainerClass(topCenterContainerElement);
    document.dispatchEvent(new CustomEvent('updateToggleStateWhenRemoveableTagsClicked'));
  }, 500);
}

function handleRemovableTagsAndClearAllBtnWhenFilterIsHidden() {
   document.dispatchEvent(new CustomEvent('updateToggleStateWhenRemoveableTagsClicked'));
}

function handleRemovableTagsAndClearAllBtn(topCenterContainerElement) {
  setTopContainerClass(topCenterContainerElement); /* everytime the top page hook runs we should set the class*/
  window.addEventListener('fs-custom-events-filter-clicked', (fsEvent) => { 
  /* 
  we need to watch for this event as well in the case that the product grid doesn't change but the tag is applied and we need to update the class
  if the removableTags were just added to dom we need to also add event listeners.
  */
    setTopContainerClass(topCenterContainerElement);
    addEventListenersForRemovableTagsWrapper(topCenterContainerElement);
  });
  addEventListenersForRemovableTagsWrapper(topCenterContainerElement);
}

function changeCanadaWideTagName(topCenterContainerElement) {
  const inStockCanadaWideName = "In Stock Canada Wide";
  if(topCenterContainerElement) {
    const removableTagsText = topCenterContainerElement.querySelectorAll('.removable-tag-text');
    const removableTagsTextArray = Array.from(removableTagsText);
    const canadaWideRemovableTag = removableTagsTextArray.filter((removableText) => removableText.textContent === fsInStockCanadaWideTag);
    if(canadaWideRemovableTag.length > 0) {
      canadaWideRemovableTag[0].textContent = inStockCanadaWideName;
    }
  }  
}

function changeInStockTagsNames(topCenterContainerElement) {
  const storeName = GetSelectedStoreName();
  const sameDayPickupTagName = fsAvailabilityFilterCheckboxTextPartialEligibleAt;
  const inStockOnlineTagName = fsAvailabilityFilterCheckboxTextInStockOnlineAtStore;
  if(topCenterContainerElement) {
    const removableTagsText = topCenterContainerElement.querySelectorAll('.removable-tag-text');
    const removableTagsTextArray = Array.from(removableTagsText);
    for(const removableText of removableTagsTextArray) {
      /* the unaltered tags from shopify include the pretty printed text so we can use includes*/
      if(removableText.textContent.includes(sameDayPickupTagName)) {
        removableText.textContent = sameDayPickupTagName;
      } else if (removableText.textContent.includes(inStockOnlineTagName)) {
        removableText.textContent = inStockOnlineTagName;
      }
    }
  }  
}

function buildAutoFilterString(filterTitle, filterPartial, filterLocation, filtersString, isFilterOn) {
  const filterTag = `${filterPartial}${filterLocation}`;
  const filterTitleAndTag = `${filterTitle},${filterTag}`;
  const filtersArr = filtersString?.split(',');
  const isAutoFilterIncluded = filtersArr?.some(filter => filter === filterTag);
  const isOtherLocationFilterIncluded = filtersArr?.some(filter => filter.includes(filterPartial));

  if(isAutoFilterIncluded) {
    isFilterOn = false; /* if the filterTitleAndTag is already in the filtersString we don't need to do the update so we set isFilter (ex. fsFilterAvailabilityOn, fsFilterClearanceOn) as false */
  } else if(isOtherLocationFilterIncluded) {
    /* if there is a matching fitlerPartial we need to remove it from the filtersString*/
    const cleanFiltersArr = filtersArr.filter(tag => tag !== filterTitle && !tag.includes(filterPartial));
    filtersString = cleanFiltersArr.join(',');
  }

  if(filtersString) { /* we are just inserting the new filterTitleAndTag if there are others or making it the first one*/
    filtersString += `,${filterTitleAndTag}`;
  } else {
    filtersString = `${filterTitleAndTag}`;
  }
  return [isFilterOn, filtersString];
}

async function setAutoFiltersMobile(fsFilterAvailabilityOn, fsFilterClearanceOn) {/* on mobile, the filters don't load unless the modal is opened so we need to set the auto filters with a redirect */
  if(window.innerWidth <= 480 && !window.location.href.includes('autofilter=false')) {
    const url = new URL(window.location.href);
    let filtersString = url.searchParams.get('filters');
    if(fsFilterAvailabilityOn) {
      
        const storeId = GetSelectedStoreId();
        [fsFilterAvailabilityOn, filtersString] = buildAutoFilterString(fsInStockFilterTitle, fsInStockOnlineFilterTagPartial, storeId, filtersString, fsFilterAvailabilityOn);
      
    }

    if(fsFilterClearanceOn) {
      const filterClearanceTitle = 'Clearance';
      const filterClearanceTagPartial = 'Clearance_Available at ';
      const storeRegion = await GetSelectedStoreRegion();
      [fsFilterClearanceOn, filtersString] = buildAutoFilterString(filterClearanceTitle, filterClearanceTagPartial, storeRegion, filtersString, fsFilterClearanceOn);
    }

    if(filtersString && (fsFilterAvailabilityOn || fsFilterClearanceOn)) {
      let updatedUrl = buildFilterUrl(url, filtersString);
      window.location.href = updatedUrl;
    }
  }
}


